import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ConstructsQuestionsComponent} from './constructs-questions.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    ConstructsQuestionsComponent,
  ],
  exports: [
    ConstructsQuestionsComponent,
  ],
})
export class ConstructsQuestionsModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/constructs/constructs-details/constructs-questions/constructs-questions.module.ts